
import Article from './Article.vue'

export default {
  components: { Article },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
}
